import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Avatar,
  Typography,
  TextField,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Skeleton,
  InputAdornment,
  Dialog,
} from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import ChatIcon from "@mui/icons-material/Chat";
import SendIcon from "@mui/icons-material/Send";
import { CustomerDetail } from "../../DAL/fetch";
import { fileUrl } from "../../Config/Config";
import { RiChatOffLine } from "react-icons/ri";
import { BsThreeDotsVertical } from "react-icons/bs";
// import rocco from "../../Assets/logo.png";
import rocco from "../../Assets//Roccologo.png";
import ChatModal from "../../Components/Models/ChatModal";
import moment from "moment";
import { SendText } from "../../DAL/create";
import { enqueueSnackbar } from "notistack";
import { Icon } from "@iconify/react";

const ChatPage = ({ selectedUser, socketData, drawerOpen, setDrawerOpen }) => {
  const chatContainerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const [usersDetail, setUserDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startTexting, setStartTexting] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [input, setInput] = useState("");
  const [lastMessage, setLastMessage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleOpenModal = (action) => {
    setSelectedAction(action);
    setAnchorEl(null);
    setModalOpen(true);
    setStartTexting(false);
  };

  const handleText = () => {
    setStartTexting(true);
    setAnchorEl(null);
  };
  const handleDone = () => {
    setStartTexting(false);
    setAnchorEl(null);
  };

  const fetchData = async () => {
    setLoading(true);
    const resp = await CustomerDetail(selectedUser.id);
    setLoading(false);
    if (resp?.status == 200) {
      setUserDetail(resp?.data?.data);
    }
  };

  useEffect(() => {
    if (
      socketData?.message &&
      socketData?.conversationId === selectedUser?.id &&
      socketData?.message !== lastMessage
    ) {
      const newMsg = {
        sender: "other",
        type: socketData.type || "text",
        message: socketData.message,
        createdAt: new Date().toISOString(),
      };

      setUserDetail((prev) => [...prev, newMsg]);
      setLastMessage(socketData.message);
    }
  }, [socketData, selectedUser]);

  const handleMessage = async () => {
    if (!input.trim()) return;

    const newMessage = {
      sender: "me",
      type: "text",
      message: input,
      createdAt: new Date().toISOString(),
    };

    // Append message to UI
    setUserDetail((prev) => [...prev, newMessage]);

    // Clear input
    setInput("");

    const payload = {
      conversationId: usersDetail.conversationId,
      customerId: selectedUser.customerId,
      teamMemberId: selectedUser.id,
      type: "text",
      message: input,
    };
    const resp = await SendText(payload);
    if (resp?.status !== 200) {
      enqueueSnackbar(
        resp?.error ||
          resp?.data?.error ||
          resp?.message ||
          resp?.data?.message,
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    if (selectedUser) {
      fetchData();
    }
  }, [selectedUser]);

  useEffect(() => {
    if (usersDetail.length > 0) {
      setTimeout(scrollToBottom, 50);
    }
  }, [usersDetail]);
  useEffect(() => {
    scrollToBottom();
  }, [usersDetail]);

  return (
    <>
      <Box
        sx={{
          background: "linear-gradient(to right, #ab6edf7a, #11c7d880)",
          borderRadius: "13px",
          m: 1,
        }}
      >
        {/* Modal */}
        <ChatModal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          actionLabel={selectedAction}
        />
        {/* Header */}
        {selectedUser === "" ? (
          <>
            <Box sx={{ height: "10vh" }}></Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "10vh",
            }}
          >
            <Box
              p={2}
              sx={{
                display: "flex",
                alignItems: "center",
                height: { lg: "27px", xs: "17px" },
              }}
            >
              <Avatar src={fileUrl + selectedUser?.customer?.picture} />
              <Typography variant="h6" ml={2}>
                {selectedUser?.customer?.name}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: "10px" }}>
              <IconButton onClick={handleClick}>
                <BsThreeDotsVertical />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                PaperProps={{
                  elevation: 3,
                  sx: {
                    minWidth: 150,
                  },
                }}
              >
                <MenuItem onClick={() => handleOpenModal("Block")}>
                  <ListItemIcon>
                    <BlockIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Block" />
                </MenuItem>
                {startTexting === false ? (
                  <MenuItem onClick={handleText}>
                    <ListItemIcon>
                      <ChatIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Start Texting" />
                  </MenuItem>
                ) : (
                  <MenuItem onClick={handleDone}>
                    <ListItemIcon>
                      <Icon
                        icon={"hugeicons:chat-done"}
                        width="20"
                        height="20"
                      />
                    </ListItemIcon>
                    <ListItemText primary="Done" />
                  </MenuItem>
                )}
              </Menu>
              <Box>
                <Button onClick={() => setDrawerOpen(true)}>
                  <Icon
                    icon={"material-symbols-light:chat-apps-script"}
                    width="40"
                    height="40"
                    className="gradientButton"
                  />
                </Button>
              </Box>
            </Box>
          </Box>
        )}
        {/* Messages */}
        <Box
          ref={chatContainerRef}
          flex={1}
          sx={{
            overflowY: "auto",
            // background: "linear-gradient(to right, #8732d17a, #11c7d880)",
            // background: "linear-gradient(#e3f6f5, #c4b5fd)",
            height: startTexting === true ? "75vh" : "85vh",
            // mt: startTexting === true ? "0vh" : "5vh",
            borderRadius: "13px",
            mx: 1,
            p: 1,
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#7E3ED6",
              borderRadius: "2px",
            },
          }}
        >
          {selectedUser ? (
            <>
              {usersDetail.length == 0 ? (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "80vh",
                    }}
                  >
                    <RiChatOffLine
                      style={{ fontSize: "100px", color: "#ccc" }}
                    />
                  </Box>
                </>
              ) : (
                <>
                  {usersDetail.map((msg, index) => (
                    <>
                      <Box
                        key={index}
                        display="flex"
                        gap={2}
                        alignItems="center"
                        justifyContent={
                          msg.sender === "me" || selectedUser?.teamMemberId
                            ? "flex-end"
                            : "flex-start"
                        }
                        mb={2}
                      >
                        <Avatar
                          src={fileUrl + selectedUser?.customer?.picture}
                        />
                        {loading === true ? (
                          <>
                            <Skeleton
                              variant="rectangular"
                              width={210}
                              height={60}
                            />
                          </>
                        ) : (
                          <>
                            <Paper
                              sx={{
                                p: 1,
                                backgroundColor:
                                  msg.sender === "me" ||
                                  selectedUser?.teamMemberId
                                    ? "#1976d2"
                                    : "#e1dede62",
                                color:
                                  msg.sender === "me" ||
                                  selectedUser?.teamMemberId
                                    ? "white"
                                    : "black",
                                borderRadius: "16px",
                                maxWidth: "60%",
                              }}
                            >
                              {msg?.type == "text" ? (
                                <>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color:
                                        msg.sender === "me" ||
                                        selectedUser?.teamMemberId
                                          ? "white"
                                          : "#7E3ED2",
                                    }}
                                  >
                                    {msg.sender === "me" ||
                                    selectedUser?.teamMemberId
                                      ? "Admin"
                                      : selectedUser?.customer?.name}
                                  </Typography>
                                  <Box sx={{ display: "flex" }}>
                                    <Box
                                      sx={{
                                        maxWidth: "100%",
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                        p: 1,
                                      }}
                                    >
                                      <Typography variant="body1">
                                        {msg?.message}
                                      </Typography>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "end",
                                        alignItems: "end",
                                      }}
                                    >
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          fontSize: "11px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {moment(msg?.createdAt).format(
                                          "hh:mm A"
                                        )}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </>
                              ) : (
                                <img
                                  src={fileUrl + msg?.message}
                                  alt="image"
                                  onClick={() =>
                                    setPreviewImage(fileUrl + msg?.message)
                                  }
                                  style={{ height: "100px", width: "100px" }}
                                />
                              )}
                            </Paper>
                          </>
                        )}
                      </Box>
                    </>
                  ))}
                </>
              )}
              <div ref={messagesEndRef} />
            </>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "80vh",
                }}
              >
                <img src={rocco} style={{ height: "100px", opacity: "0.4" }} />
                <Typography
                  variant="h5"
                  sx={{ color: "#6e6b6bff", fontStyle: "italic" }}
                >
                  Select the Chat to Start Chatting
                </Typography>
              </Box>
            </>
          )}
        </Box>
        {/* conditions for chat or submittion */}
        {startTexting == true ? (
          <Box
            sx={{
              display: "flex",
              width: "100%",
            }}
          >
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Type your message..."
              value={input}
              size="small"
              sx={{ m: 1 }}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleMessage()}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleMessage}>
                      <SendIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        ) : (
          <></>
        )}
      </Box>
      <Dialog
        open={Boolean(previewImage)}
        onClose={() => setPreviewImage(null)}
        maxWidth="sm"
        fullWidth
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <img
            src={previewImage}
            alt="preview"
            style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "8px" }}
          />
        </Box>
      </Dialog>
    </>
  );
};

export default ChatPage;
